module.exports = __webpack_public_path__ + "static/media/spice-jet-logo.dfa7f3af.jpg";